import React from "react";
import styles from "./Tabs.module.scss";

const Tabs = ({ stage, setStage }) => {
  return (
    <div className={styles.container}>
      <ul>
        <li
          className={stage === 0 ? styles.active : ""}
          onClick={() => setStage(0)}
        >
          Public Collections
        </li>
        <li
          className={stage === 1 ? styles.active : ""}
          onClick={() => setStage(1)}
        >
          Private collections
        </li>
        <li
          className={stage === 2 ? styles.active : ""}
          onClick={() => setStage(2)}
        >
          Favorites
        </li>
        <li
          className={stage === 3 ? styles.active : ""}
          onClick={() => setStage(3)}
        >
          Transfers
        </li>
      </ul>
    </div>
  );
};

export default Tabs;
